import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import { ReactComponent as PencilEditIcon } from 'icons/pencilEditIcon.svg';
import { EditableTitle } from '../titles/PageTitle';


class ClickToEdit extends React.Component {
  constructor() {
    super();
    this.state = {
      onEditMode: false,
      fronzenWidth: 0,
    };
    this.input = React.createRef();
    this.frozenInput = React.createRef();
  }

  getIntoEditMode = () => {
    const frozenRef = this.frozenInput.current;
    this.setState({
      onEditMode: true,
      fronzenWidth: frozenRef.clientWidth,
    });
  };

  getOffEditMode = () => {
    this.setState({
      onEditMode: false,
    });
    const isDifferent = this.props.value !== this.input.current.value;
    if (this.props.endEditing && isDifferent) {
      this.props.endEditing(this.input.current.value);
    }
  };

  handleKeys = (e) => {
    if (e.key === 'Enter') {
      this.setState({
        onEditMode: false,
      });
      const isDifferent = this.props.value !== this.input.current.value;
      if (this.props.endEditing && isDifferent) {
        this.props.endEditing(this.input.current.value);
      }
    } else if (e.key === 'Escape') {
      this.setState({
        onEditMode: false,
      });
    }
  };

  render() {
    const { disabled, editIcon } = this.props;
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
      <section
        className={classNames('form-edit-inline--wrapper', this.props.wrapperClass, { 'no-icon': !editIcon })}
        onClick={disabled && editIcon ? () => {} : this.getIntoEditMode}
        ref={this.frozenInput}
        style={{ width: this.state.onEditMode ? this.state.fronzenWidth : 'unset' }}
      >
        {this.state.onEditMode ? (
          <input
            type="text"
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            style={{ width: this.state.fronzenWidth }}
            defaultValue={this.props.value}
            className={classNames('form-edit-inline--input', this.props.inputClass)}
            onKeyDown={this.handleKeys}
            onBlur={this.getOffEditMode}
            ref={this.input}
          />
        ) : (
          <>
            <EditableTitle textClass={this.props.textClass} value={this.props.value} />
            {editIcon &&
              <IconButton onClick={disabled ? () => {} : this.getIntoEditMode}>
                <PencilEditIcon />
              </IconButton>
            }
          </>
        )}
      </section>
    );
  }
}

ClickToEdit.propTypes = {
  wrapperClass: PropTypes.string,
  inputClass: PropTypes.string,
  textClass: PropTypes.string,
  value: PropTypes.string.isRequired,
  endEditing: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  editIcon: PropTypes.bool,
};

ClickToEdit.defaultProps = {
  wrapperClass: '',
  inputClass: '',
  textClass: '',
  disabled: false,
  editIcon: false,
};

export default ClickToEdit;
